{
  "familyId": "GELD-SPAREN",
  "questions": [
    {
      "id": "GELD-SPAREN-001",
      "familyId": "GELD-SPAREN",
      "module": "Geld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_sparen",
      "questionType": "multiple_choice",
      "question": "Lotte spaart elke week €5. Na hoeveel weken heeft ze €60 gespaard?",
      "options": ["12 weken", "10 weken", "15 weken", "6 weken"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Sparen berekenen", "content": "Als je elke week hetzelfde bedrag spaart, deel je het totaal door het weekbedrag. Totaal ÷ per week = aantal weken.", "icon": "lightbulb" } }],
      "conceptId": "sparen_weken_berekenen",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 2, "misconceptionTags": [
          { "id": "geld.deling-te-laag", "label": "Deelt te laag: denkt 10 weken", "optionIndex": 1 },
          { "id": "geld.deling-te-hoog", "label": "Deelt te hoog: denkt 15 weken", "optionIndex": 2 },
          { "id": "geld.verkeerd-deeltal", "label": "Deelt door verkeerd getal", "optionIndex": 3 }
        ] },
      "feedback": {
        "explanationText": "Lotte spaart €5 per week en wil €60 hebben. Om te berekenen hoeveel weken dat duurt, deel je het spaardoel door het weekbedrag: €60 ÷ €5 = 12 weken. Controleer: 12 × €5 = €60 ✓.",
        "solutionSteps": ["Totaal nodig: €60", "Per week: €5", "Aantal weken: €60 ÷ €5 = 12 weken", "Controleer: 12 × €5 = €60 ✓"],
        "distractorExplanations": {
          "0": "Goed! €60 ÷ €5 = 12 weken. Controleer: 12 × €5 = €60 ✓.",
          "1": "Je dacht waarschijnlijk aan 10 weken. Maar 10 × €5 = €50, en dat is €10 te weinig voor €60. Onthoud: deel het spaardoel door het weekbedrag: €60 ÷ €5 = 12.",
          "2": "Je dacht waarschijnlijk aan 15 weken. Maar 15 × €5 = €75, en dat is €15 te veel. Onthoud: €60 ÷ €5 = 12, niet 15.",
          "3": "Je dacht waarschijnlijk dat je €60 ÷ €10 moest doen. Maar Lotte spaart €5 per week, niet €10. Onthoud: lees goed hoeveel ze per week spaart."
        }
      }
    },
    {
      "id": "GELD-SPAREN-002",
      "familyId": "GELD-SPAREN",
      "module": "Geld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_sparen",
      "questionType": "multiple_choice",
      "question": "Sem heeft €120 op zijn spaarrekening. Hij krijgt 5% rente per jaar. Hoeveel rente krijgt hij na één jaar?",
      "options": ["€6", "€5", "€12", "€60"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Rente berekenen", "content": "Rente = bedrag × percentage ÷ 100. Dus: €120 × 5 ÷ 100 = €6.", "icon": "lightbulb" } }],
      "conceptId": "rente_basis_berekenen",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2, "misconceptionTags": [
          { "id": "geld.percent-equals-amount", "label": "Denkt dat 5% altijd €5 is", "optionIndex": 1 },
          { "id": "geld.wrong-percentage-calc", "label": "Berekent 10% i.p.v. 5%", "optionIndex": 2 },
          { "id": "geld.wrong-percentage-calc", "label": "Berekent 50% i.p.v. 5%", "optionIndex": 3 }
        ] },
      "feedback": {
        "explanationText": "Rente bereken je door het bedrag te vermenigvuldigen met het percentage en te delen door 100. Sem heeft €120 en krijgt 5% rente: €120 × 5 ÷ 100 = €6. Na één jaar heeft hij €120 + €6 = €126 op zijn rekening.",
        "solutionSteps": ["Bedrag: €120", "Rente: 5%", "Berekening: €120 × 5 ÷ 100 = €6", "Controle: na 1 jaar: €120 + €6 = €126"],
        "distractorExplanations": {
          "0": "Goed! 5% van €120 = €6.",
          "1": "Je dacht waarschijnlijk dat 5% altijd €5 is. Maar 5% hangt af van het bedrag: 5% van €100 = €5, maar 5% van €120 = €6. Onthoud: percentage × bedrag ÷ 100.",
          "2": "Je dacht waarschijnlijk dat je 10% moest berekenen. Maar de rente is 5%, niet 10%. 10% van €120 = €12, maar 5% = €6. Onthoud: lees het percentage goed.",
          "3": "Je dacht waarschijnlijk dat je 50% moest berekenen. Maar 5% is niet hetzelfde als 50%. 5% = 5 van de 100, 50% = de helft. Onthoud: 5% is een klein deel van het bedrag."
        }
      }
    },
    {
      "id": "GELD-SPAREN-003",
      "familyId": "GELD-SPAREN",
      "module": "Geld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_sparen",
      "questionType": "multiple_choice",
      "question": "Mila spaart elke maand €15. Ze wil een fiets kopen van €180. Na hoeveel maanden heeft ze genoeg?",
      "options": ["12 maanden", "10 maanden", "15 maanden", "18 maanden"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Spaardoel berekenen", "content": "Deel het spaardoel door het maandbedrag: €180 ÷ €15 = 12 maanden.", "icon": "lightbulb" } }],
      "conceptId": "spaardoel_maanden",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2, "misconceptionTags": [
          { "id": "geld.deling-te-laag", "label": "Deelt te laag: denkt 10 maanden", "optionIndex": 1 },
          { "id": "geld.deling-te-hoog", "label": "Deelt te hoog: denkt 15 maanden", "optionIndex": 2 },
          { "id": "geld.verkeerd-deeltal", "label": "Deelt door verkeerd getal (€10 i.p.v. €15)", "optionIndex": 3 }
        ] },
      "feedback": {
        "explanationText": "Mila spaart €15 per maand voor een fiets van €180. Om te berekenen hoeveel maanden dat duurt, deel je het spaardoel door het maandbedrag: €180 ÷ €15 = 12 maanden. Controleer: 12 × €15 = €180 ✓.",
        "solutionSteps": ["Spaardoel: €180", "Per maand: €15", "Aantal maanden: €180 ÷ €15 = 12", "Controleer: 12 × €15 = €180 ✓"],
        "distractorExplanations": {
          "0": "Goed! €180 ÷ €15 = 12 maanden. Controleer: 12 × €15 = €180 ✓.",
          "1": "Je dacht waarschijnlijk aan 10 maanden. Maar 10 × €15 = €150, en dat is €30 te weinig voor de fiets van €180. Onthoud: deel het spaardoel door het maandbedrag.",
          "2": "Je dacht waarschijnlijk aan 15 maanden. Maar 15 × €15 = €225, en dat is €45 meer dan nodig. Onthoud: €180 ÷ €15 = 12.",
          "3": "Je dacht waarschijnlijk dat je €180 ÷ €10 moest doen. Maar Mila spaart €15 per maand, niet €10. Onthoud: lees het maandbedrag goed."
        }
      }
    },
    {
      "id": "GELD-SPAREN-004",
      "familyId": "GELD-SPAREN",
      "module": "Geld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_sparen",
      "questionType": "multiple_choice",
      "question": "Daan heeft €200 op zijn spaarrekening. Na een jaar staat er €210. Hoeveel procent rente heeft hij gekregen?",
      "options": ["5%", "10%", "2%", "15%"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Rentepercentage berekenen", "content": "Bereken eerst hoeveel erbij is gekomen. Deel dat door het beginbedrag en vermenigvuldig met 100. Rente = (verschil ÷ beginbedrag) × 100.", "icon": "lightbulb" } }],
      "conceptId": "rente_percentage_terugrekenen",
      "variantIndex": 4,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 2, "misconceptionTags": [
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Denkt dat €10 op €200 = 10%", "optionIndex": 1 },
          { "id": "geld.wrong-percentage-calc", "label": "Berekent percentage verkeerd: 2%", "optionIndex": 2 },
          { "id": "geld.wrong-percentage-calc", "label": "Berekent percentage verkeerd: 15%", "optionIndex": 3 }
        ] },
      "feedback": {
        "explanationText": "Om het rentepercentage te berekenen, bereken je eerst hoeveel erbij is gekomen: €210 − €200 = €10. Daarna deel je dat door het beginbedrag en vermenigvuldig je met 100: €10 ÷ €200 × 100 = 5%. Daan heeft 5% rente gekregen.",
        "solutionSteps": ["Verschil: €210 − €200 = €10", "Percentage: €10 ÷ €200 = 0,05", "In procenten: 0,05 × 100 = 5%", "Controleer: 5% van €200 = €10 ✓"],
        "distractorExplanations": {
          "0": "Goed! €10 ÷ €200 × 100 = 5%.",
          "1": "Je dacht waarschijnlijk dat €10 op €200 gelijk is aan 10%. Maar €10 is 5% van €200, niet 10%. 10% van €200 zou €20 zijn. Onthoud: deel het verschil door het beginbedrag.",
          "2": "Je dacht waarschijnlijk dat het 2% is. Maar 2% van €200 = €4, en er is €10 bijgekomen — dat is meer dan €4. Onthoud: €10 ÷ €200 × 100 = 5%.",
          "3": "Je dacht waarschijnlijk dat het 15% is. Maar 15% van €200 = €30, en er is maar €10 bijgekomen — dat is veel minder dan €30. Onthoud: deel het verschil door het beginbedrag."
        }
      }
    },
    {
      "id": "GELD-SPAREN-005",
      "familyId": "GELD-SPAREN",
      "module": "Geld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_sparen",
      "questionType": "fill_in",
      "question": "Eva spaart elke week €8. Hoeveel heeft ze na 6 weken gespaard? Typ het bedrag in euro's (bijv. 48).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["48", "€48", "48,00", "€48,00"],
        "fill_in": {
          "inputType": "text",
          "placeholder": "€...",
          "unit": "",
          "acceptedAnswers": ["48", "€48", "48,00", "€48,00"],
          "caseSensitive": false
        }
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Totaal gespaard berekenen", "content": "Vermenigvuldig het weekbedrag met het aantal weken: €8 × 6 = €48.", "icon": "lightbulb" } }],
      "conceptId": "sparen_totaal_berekenen_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Eva spaart €8 per week, 6 weken lang. Om het totaal te berekenen, vermenigvuldig je het weekbedrag met het aantal weken: €8 × 6 = €48. Controleer: €48 ÷ 6 = €8 per week ✓.",
        "solutionSteps": ["Per week: €8", "Aantal weken: 6", "Totaal: €8 × 6 = €48", "Controleer: €48 ÷ 6 = €8 ✓"]
      }
    },
    {
      "id": "GELD-SPAREN-006",
      "familyId": "GELD-SPAREN",
      "module": "Geld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_sparen",
      "questionType": "fill_in",
      "question": "Tim spaart elke week €7. Na 8 weken heeft hij al €20 op zijn rekening staan. Hoeveel heeft hij dan in totaal? Typ het bedrag in euro's (bijv. 76).",
      "correctAnswer": "76",
      "data": {
        "acceptedAnswers": ["76", "€76", "76,00", "€76,00"],
        "placeholder": "totaalbedrag in €",
        "inputType": "number"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Sparen met startbedrag", "content": "Totaal = startbedrag + (per week × aantal weken). Hier: €20 + (€7 × 8) = €20 + €56 = €76.", "icon": "lightbulb" } }
      ],
      "conceptId": "sparen_fill_in_startbedrag",
      "variantIndex": 6,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Tim heeft al €20 en spaart er €7 per week bij. Na 8 weken: €7 × 8 = €56 gespaard. Totaal: €20 + €56 = €76.",
        "solutionSteps": [
          "Startbedrag: €20",
          "Gespaard: €7 × 8 = €56",
          "Totaal: €20 + €56 = €76"
        ]
      }
    },
    {
      "id": "GELD-SPAREN-007",
      "familyId": "GELD-SPAREN",
      "module": "Geld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_sparen",
      "questionType": "fill_in",
      "question": "Sara wil een cadeau van €45 kopen. Ze spaart €6 per week. Na hoeveel weken heeft ze genoeg? Typ het aantal weken (bijv. 8).",
      "correctAnswer": "8",
      "data": {
        "acceptedAnswers": ["8"],
        "placeholder": "aantal weken",
        "inputType": "number"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Spaardoel berekenen", "content": "Aantal weken = spaardoel ÷ weekbedrag. €45 ÷ €6 = 7,5. Je kunt geen halve week sparen, dus naar boven afronden: 8 weken.", "icon": "lightbulb" } }
      ],
      "conceptId": "sparen_fill_in_weken_afronden",
      "variantIndex": 7,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "€45 ÷ €6 = 7,5 weken. Maar je kunt geen halve week sparen — na 7 weken heeft Sara €42 (niet genoeg). Na 8 weken: €48 (genoeg!). Antwoord: 8 weken.",
        "solutionSteps": [
          "Spaardoel: €45, per week: €6",
          "€45 ÷ €6 = 7,5 weken",
          "Naar boven afronden: 8 weken",
          "Controleer: 8 × €6 = €48 ≥ €45 ✓"
        ]
      }
    },
    {
      "id": "GELD-SPAREN-008",
      "familyId": "GELD-SPAREN",
      "module": "Geld",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "geld_toegepast",
      "subSkill": "geld_sparen",
      "questionType": "step_solver",
      "question": "Noor zet €250 op haar spaarrekening. Ze krijgt 4% rente per jaar en spaart er ook nog €15 per maand bij. Reken stap voor stap uit hoeveel ze na 1 jaar in totaal op haar rekening heeft.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "stepSolver": {
          "context": "",
          "steps": [
            {
              "prompt": "Hoeveel rente krijgt Noor over haar startbedrag van €250 in één jaar? (4% van €250 in euro)",
              "correctAnswer": "10",
              "acceptedAnswers": ["10", "€10", "10,00", "€10,00"],
              "hint": "Rente = bedrag × percentage ÷ 100. Dus €250 × 4 ÷ 100 = ?"
            },
            {
              "prompt": "Hoeveel spaart Noor er in een jaar bij van haar maandinleg? (€15 per maand × 12 maanden in euro)",
              "correctAnswer": "180",
              "acceptedAnswers": ["180", "€180", "180,00", "€180,00"],
              "hint": "Er zitten 12 maanden in een jaar. Vermenigvuldig de maandinleg met 12."
            },
            {
              "prompt": "Wat staat er na 1 jaar in totaal op de rekening? (startbedrag + rente + bijgespaard in euro)",
              "correctAnswer": "440",
              "acceptedAnswers": ["440", "€440", "440,00", "€440,00"],
              "hint": "Tel alles bij elkaar op: €250 + €10 + €180."
            }
          ],
          "showStepsProgressively": true
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stappenplan sparen met rente én inleg",
            "content": "Stap 1: Bereken de jaarrente over het startbedrag (bedrag × percentage ÷ 100). Stap 2: Bereken hoeveel je in een jaar bijspaart (maandinleg × 12). Stap 3: Tel alles op: startbedrag + rente + bijgespaard = eindbedrag. Let op: rente wordt hier alleen over het startbedrag berekend, niet over de nieuwe inleg.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "sparen_step_solver_rente_plus_inleg",
      "variantIndex": 8,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": []
      },
      "feedback": {
        "explanationText": "Noor combineert rente met maandelijks bijsparen. Stap 1: rente = €250 × 4 ÷ 100 = €10. Stap 2: bijgespaard = €15 × 12 = €180. Stap 3: totaal = €250 + €10 + €180 = €440. Na één jaar staat er €440 op haar rekening.",
        "solutionSteps": [
          "Startbedrag: €250",
          "Jaarrente (4%): €250 × 4 ÷ 100 = €10",
          "Bijgespaard in 12 maanden: €15 × 12 = €180",
          "Totaal: €250 + €10 + €180 = €440"
        ]
      }
    }
  ]
}